import React from "react";
import { useSelector } from "react-redux";
import NumberDisplay from "../../../../components/numberDisplay/numberDisplay";
import PercentChanged from "../../../../components/percentChanged/percentChanged";
import SectionContainer from "../../../../components/sectionContainer/sectionContainer";

const FrozenMembersStats = () => {
  const { frozenMembers, frozenMembersRawDataLink, tooltip, frozenMembersChange } = useSelector(
    (state) => state.membershipSales.statistics.frozenMembers
  );
  const isUserQa = useSelector((state) => state.commonReducer.commonProps.qa);

  return (
    <SectionContainer
      title="Frozen Members"
      toolTip={tooltip}
      toolTipId="membershipDetailsFrozenMembers"
    >
      <NumberDisplay
        value={frozenMembers}
        url={frozenMembersRawDataLink}
        disableAnimation={isUserQa}
        toolTipId="membershipDetailsFrozenMembers"
        toolTipContent={tooltip}
      />
      <PercentChanged
        changeValue={frozenMembersChange}
        toolTip="Percentage change"
        showBorder
        positiveColor="#c7343e"
        negativeColor="#21e981"
      />
    </SectionContainer>
  );
};

export default FrozenMembersStats;
